import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { ThfDynamicModule, ThfModalModule, ThfPageModule } from '@totvs/thf-ui';

import { ThfAdvancedFilterComponent } from './thf-advanced-filter/thf-advanced-filter.component';
import { ThfPageDynamicSearchComponent } from './thf-page-dynamic-search.component';

/**
 * @description
 *
 * MÃ³dulo do template do thf-page-dynamic-search.
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,

    ThfDynamicModule,
    ThfModalModule,
    ThfPageModule
  ],
  declarations: [
    ThfAdvancedFilterComponent,
    ThfPageDynamicSearchComponent
  ],
  exports: [
    ThfPageDynamicSearchComponent
  ]
})
export class ThfPageDynamicSearchModule { }
